<template>
  <div class="page">
    探索
  </div>
</template>

<script>
export default {
  name: 'Discovery'
}
</script>

<style>

</style>
